export const fr = {
  form_disable: "",
  person_detail: "Information élève",
  person_firstname: "Prénom",
  student_firstname: "Prénom de l'élève",
  person_lastname: "Nom",
  student_lastname: "Nom de l'élève",
  person_email: "E-mail",
  student_birthdate: "Date de naissance de l'élève",
  person_birthdate: "Date de naissance",
  phone_prefix: "Préfix",
  phone_number: "Téléphone",
  discipline: "Discipline(s)",
  discipline_add: "Ajouter une discipline",
  discipline_disciplines: "Disciplines",
  discipline_courses: "Cours",
  discipline_schedule: "Horaire",
  discipline_schedule_add: "Ajouter un horaire",
  discipline_schedule_occurence: "min. {occurence} occurences/semaine",
  discipline_remove: "Supprimer la discipline",
  on_demand: "Merci de prendre directement contact avec l'école pour ce cours.",
  to_confirm: "Horaires à venir.",
  to_confirm_hours: "(horaires à venir)",
  schedule_full_title: "Cours complet",
  schedule_full_message:
    "Ce cours est complet. Votre inscription sera placée en file d'attente et l'école vous recontactera si une place se libère.",
  schedule_full_close: "J'ai compris",
  register: "s'inscrire",
  registrtation: "Inscription élève",
  registration_error:
    "Votre demande d'inscription n'a pas été soumise. Une erreur technique est survenue.{br}{br}Veuillez recommencer plus tard.",
  registration_error_close: "Fermer",
  registration_success:
    "Votre demande d'inscription a été soumise avec succès.",
  important: "IMPORTANT:",
  check_junk:
    "Si vous ne recevez pas de confirmation par e-mail, merci de vérifier vos courriers indésirables. ",
  no_mail_contact_us:
    "Si vous n'avez pas reçu de mail après 1h, merci de nous contacter par e-mail.",
  responsible: "Contact(s) supplémentaire(s)",
  responsible_info:
    "Vous avez la possibilité d'ajouter un ou plusieurs contacts supplémentaires. " +
    "Il ne s'agit pas d'une deuxième inscription, mais uniquement d'une personne à contacter en cas d'urgence.",
  responsible_add: "Ajouter un contact",
  responsible_remove: "Supprimer le contact",
  address: "Adresse",
  address_number: "Numéro",
  address_street: "Rue",
  address_postal_code: "Code Postal",
  address_city: "Ville",
  address_country: "Pays",
  rgpd: "RGPD & Traitement des données personnelles ",
  copyright: " Droit à l'image",
  form_error_title: "Erreur",
  form_error_minor:
    "L'inscrit est mineur, un responsable doit être renseigné !",
  must_be_adult: "Le contact supplémentaire doit être majeur pour continuer.",
  form_info_contact_link: "Formulaire de contact",
  error_required_schedule: "Sélectionné un horaire",
  form_info_unit_course_title: "Cours à l'unité",
  form_info_unit_course:
    "Ces cours ne se réservent pas dans ce formulaire. Merci de contacter l'école. ",
  form_info_unit_course_link: "Cours à l'unité",
  form_not_available:
    "Le formulaire d'inscription n'est pas disponible pour le moment.",
  form_invalid_alert_title: "Attention : Formulaire non valide",
  form_invalid_alert:
    "Veuillez corriger les champs marqués en rouge, puis soumettre à nouveau le formulaire.",
  error_title: "Quelque chose ne s'est pas bien passé.",
  error_text_1: "Merci de nous contacter via le fomulaire de contact : ",
  error_text_2: "Vous pouvez aussi nous contacter directement par mail : ",
  error_text_generic: "Merci de réessayer plus tard ou de contacter l'école.",
};
